<template>
  <section class="_menu-section-style">
    <form-section label="Grade de ingressos" v-model="isExpanded.ticketsGrid">
      <div v-if="isNewLayout" class="py-4">
        <component :is="getLayoutComponent" :selectedSection="selectedSection" :key="selectedSection.layout"/>
      </div>

      <div :class="['_subtitleFormFont', {'my-3': isNewLayout}]"><b>Layouts:</b></div>

      <div class="layout-container">
        <div 
          v-for="(layout, index) in typesLayout" 
          :key="index"
          :class="['layout-container-cell', {'selected-cell' : selectedSection.layout === layout.value}]"
          @click="handleChangeLayout(layout.value)"
        >
          <v-icon v-if="selectedSection.layout !== layout.value" color="grey lighten-2" size="18">fa-regular fa-circle</v-icon>
          <v-icon v-else color="#0079CB" size="18">fa-solid fa-circle-check</v-icon>
          <span>{{layout.name}}</span>
        </div>
      </div>

      <div v-if="showConfigBtnForOldLayouts" class="d-flex flex-column pt-3 pb-1">
        <ButtonV2
          :label="!showConfig ? 'Configurar layout': 'Esconder configuração'" 
          color="bt_color_bg"
          textSize="0.80rem"
          :disabled="selectedSection.layout.includes('new') && products === null"
          :textColor="selectedSection.layout.includes('new') && products === null ? 'gray' : 'bt_color'"
          :icon="!showConfig ? 'fa-solid fa-sliders-simple': 'fa-regular fa-eye-slash'"
          @click="handleConfigLayout"
        />      
      </div>

      <div v-if="showOptionsForOldLayouts" class="py-4">
        <component :is="getLayoutComponent" :selectedSection="selectedSection" :key="selectedSection.layout"/>
      </div>        
    </form-section>

    <form-section label="Título" v-model="isExpanded.title">
      <Texts textType="title" :sectionType="selectedSection.type" :selectedSection="selectedSection" :hide="['alignment']"/>
    </form-section>

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts 
        textType="subtitle" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"
        useTextArea
      />
    </form-section>

    <form-section label="Observação" v-model="isExpanded.observations">
      <OtherTexts 
        textType="observation" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"
        :customEditorToolbar="[['bold', 'italic', 'underline'], ['link']]"
      />
    </form-section>

    <form-section label="Botão" v-model="isExpanded.button">
      <Buttons 
        :sectionsId="sectionsId" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection.buttons[0]"
        :hasBindedStyle="hasBindedStyle" 
        :hide="['alignment', 'action', 'content']"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg" :divider="false">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        @update="onUpdateBackground"
      />
    </form-section>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import FormSection from '../../_v2/utils/FormSection.vue'
import ButtonV2 from '../../_v2/ui/Button.vue'
import Texts from '../forms/formsV2/Texts.vue'
import OtherTexts from '../forms/formsV2/OtherTexts.vue'
import Buttons from '../forms/formsV2/Buttons.vue'
import Background from '../forms/formsV2/Background.vue'
import isEmpty from './isEmpty.vue'

// Layouts
import horizontal from '../forms/formsV2/tickets/Layout1.vue'
import vertical from '../forms/formsV2/tickets/Layout2.vue'
import formLayout from '../forms/formsV2/tickets/Layout3.vue'
import custom from '../forms/formsV2/tickets/Layout4.vue'
import newLayout1 from'../forms/formsV2/tickets/newLayout1.vue'
import newLayout2 from'../forms/formsV2/tickets/newLayout2.vue'
import newLayout3 from'../forms/formsV2/tickets/newLayout3.vue'
import newLayout4 from'../forms/formsV2/tickets/newLayout4.vue'
import newLayout5 from'../forms/formsV2/tickets/newLayout5.vue'
import newLayout6 from'../forms/formsV2/tickets/newLayout6.vue'

export default {
  name: 'TicketsSection',
  components: { 
    FormSection, 
    Texts, 
    OtherTexts,
    Buttons, 
    Background, 
    isEmpty, 
    ButtonV2,
    // Layouts 
    horizontal,
    vertical,
    formLayout,
    custom,
    newLayout1,
    newLayout2,
    newLayout3,
    newLayout4,
    newLayout5,
    newLayout6,
  },
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },
  computed: {
    ...mapGetters(['products']),
    getLayoutComponent () {
      if (this.selectedSection.layout === 'form') return 'formLayout'
      else return this.selectedSection.layout
    },

    hasBindedStyle () {
      return this.selectedSection.idLayout ? true : false
    },

    isNewLayout () {
      return this.selectedSection.layout && this.selectedSection.layout.includes('new')
    },

    showConfigBtnForOldLayouts () {
      return this.selectedSection.layout && !this.selectedSection.layout.includes('new')      
    },

    showOptionsForOldLayouts () {
      return this.showConfig && this.selectedSection.layout && !this.selectedSection.layout.includes('new')
    }
  },

  data: () => ({
    isExpanded: {ticketsGrid: true, title: false, subtitle: false, observations: false, button: false, bg: false},
    typesLayout: [
      { name: "Layout 01", value: "horizontal" },
      { name: "Layout 02", value: "vertical" },
      { name: "Layout 03", value: "form" },
      { name: "Layout 04", value: "custom" },
      { name: "Layout 05", value: "newLayout1" },
      { name: "Layout 06", value: "newLayout2" },
      { name: "Layout 07", value: "newLayout3" },
      { name: "Layout 08", value: "newLayout4" },
      { name: "Layout 09", value: "newLayout5" },
      { name: "Layout 10", value: "newLayout6" },
    ],
    showConfig: true        
  }),

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    handleChangeLayout (layoutType) {
      this.selectedSection.layout = layoutType
    },

    handleConfigLayout () {
      this.showConfig = !this.showConfig
    }
  }    
}
</script>

<style scoped>
.layout-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 12px;
}

.layout-container-cell {
  display: flex;
  gap: 12px;
  height: 40px;
  width: 134px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  border: #EDEDF1 1px solid;
  background-color: #F6F7F7;
  cursor: pointer;
  transform: all 0.5s;
}

.selected-cell {
  border: #B9E2FE 1px solid;
  background-color: #F0F8FF;
}

.layout-container::-webkit-scrollbar {
  width: 8px;
}

.layout-container::-webkit-scrollbar-thumb {
  background-color: rgba(245, 247, 249, 1);
  border-radius: 5px;
}

.layout-container::-webkit-scrollbar-track {
  background-color: white;
}
</style>